import {
    DEALERLISTPARTNER_SUCCESS,
    DEALERLISTPARTNER_FAILED,
    RESET_DEALERLISTPARTNER,
    LOADING_DEALERLISTPARTNER,
    NETWORK_ERROR_DEALERLISTPARTNER
} from "../types/index";


const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERLISTPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERLISTPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERLISTPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERLISTPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERLISTPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};